import React from "react";
import { cn } from "../ui/utils";

export interface PageContainerProps {
  className?: string;
  children: React.ReactNode;
}

export function PageContainer({ children, className }: PageContainerProps) {
  return (
    <div className={cn("flex w-full flex-col gap-6", className)}>
      {children}
    </div>
  );
}
